import { Component, NgZone } from "@angular/core";
import { NavController, NavParams, AlertController } from "ionic-angular";
import { APIServiceProvider } from "./../../../common/services/api.service";
import { HelperServiceProvider } from "./../../../common/services/helper.service";
import { NotifyService  } from '../../../services/notify.service';

@Component({
	selector: "page-settlementspending",
	templateUrl: "settlementspending.html"
})
export class SettlementsPendingPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public apiHelper: APIServiceProvider,
		public alertController: AlertController,
		private notifyService: NotifyService
	) {}

	public postParams: any = {
		status: -1
	};

	public disableSubmission = false;
	public settlements: any = [];
	public pagination = null;
	public searchText = null;
	public loggedInUser = localStorage.getItem("user-id");

	public settlementUrl = "settlement/all";

	ionViewDidLoad() {
		this.getSettlements(this.settlementUrl);
	}

	getSettlements(url, refresh?) {
		this.apiHelper.post(url, this.postParams).subscribe(
			response => {
				this.settlements = response["data"]["data"];
				this.pagination = response["data"];
				if (refresh) {
					refresh.complete();
				}
			},
			error => {}
		);
	}

	doRefresh(refresher) {
		this.getSettlements(this.settlementUrl, refresher);
	}

	doInfiniteScroll(event) {
		if (
			!this.pagination.next_page_url ||
			this.pagination.next_page_url === "" ||
			this.pagination.next_page_url === null ||
			this.pagination.next_page_url === "null"
		) {
			event.complete();
			return;
		} else {
			this.apiHelper
				.post(null, this.postParams, this.pagination["next_page_url"])
				.subscribe(
					response => {
						this.settlements = this.settlements.concat(
							response["data"]["data"]
						);
						this.pagination = response["data"];
						event.complete();
					},
					error => {}
				);
			return;
		}
	}

	search(text) {
		this.postParams["search"] = this.searchText;
		this.getSettlements(this.settlementUrl);
	}

	clearSearch(text) {
		delete this.postParams["search"];
		this.getSettlements(this.settlementUrl);
	}

	confirmSettlement(transaction){
		let postData = {transaction_id:transaction['transaction_id'],status:1};
		const alert = this.alertController.create({
			title: 'Confirmation',
			message: "<p>Confirm submission of </br> ₹ " + transaction.amount + " from " + transaction.frombydata.user_name+"</p>",
			buttons: [
				{
					text: 'Approve',
					handler: () => {
						this.updateSettlement(postData);
					}
				},
				{text: 'Cancel',role: 'cancel'} 
			]
		});
		alert.present();
	}
	
	rejectSettlement(transaction){
		let postData = { transaction_id: transaction['transaction_id'], status: 0 };
		const alert = this.alertController.create({
			title: 'Confirmation',
			message: "<p>Reject submission of </br> ₹ " + transaction.amount + " from " + transaction.frombydata.user_name+"</p>",
			buttons: [
				{
					text: 'Reject',
					handler: () => {
						this.updateSettlement(postData);
					}
				},
				{text: 'Cancel',role: 'cancel'} 
			]
		});
		alert.present();
	}

	updateSettlement(postData){
		this.disableSubmission = true;
		this.apiHelper.put('settlement/update-settlement',postData)
		.subscribe(data=>{
			this.notifyService.UpdateDashboard(true);
			this.getSettlements(this.settlementUrl);
			this.disableSubmission = false;
			this.helperService.presentToast(
				"Success"
			);
		},err=>{
			this.helperService.presentToast(
				"Some error occurred, please refresh and try again"
			);
			this.disableSubmission = false;
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/settlement/settlementspending/settlementspending.ts